import {
  THAMSO_COUNT_ASSIGN_SUCCESS,
  THAMSO_HISTORY_LIST_SUCCESS,
  THAMSO_IMPORT_SUCCESS,
  THAMSO_LIST_SUCCESS,
  THAMSO_NEW_CARE_SUCCESS,
  THAMSO_ONE_SUCCESS,
} from 'src/actions/thamso.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

const initState = {
  items: [],
  total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const thamsoReducer = (state = initState, action) => {
  switch (action.type) {
    case THAMSO_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case THAMSO_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case THAMSO_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case THAMSO_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case THAMSO_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case THAMSO_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default thamsoReducer